import React from 'react'

function Frontend() {
  return (
    <div className="skills__content">
        <h3 className="skills__tittle">Frontend</h3>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    
                    <div>
                        <h3 className="skills__name">HTML</h3>
                        
                    </div>
                </div>
                
                <div className="skills__data">
                    
                    <div>
                        <h3 className="skills__name">CSS</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                    
                    <div>
                        <h3 className="skills__name">BOOTSTRAP</h3>
                        
                    </div>
                </div>
               
            </div>
            <div className="skills__group">
                <div className="skills__data">
                    
                    <div>
                        <h3 className="skills__name">JS</h3>
                        
                    </div>
                </div>
                
                <div className="skills__data">
                    
                    <div>
                        <h3 className="skills__name">REACT</h3>
                        
                    </div>
                </div>
                <div className="skills__data">
                    
                    <div>
                        <h3 className="skills__name">GIT</h3>
                        
                    </div>
                </div>
               
            </div>
        </div>
    </div>
  )
}

export default Frontend